// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"5398b6cc","751":"03597ffc","765":"d812a3f3","787":"18ca23d6","895":"5e3d6d0f"}[chunkId] + ".chunk.js";
};